import React from 'react'
import { useRef } from "react";
import { motion, useCycle } from "framer-motion";
import { MenuToggle } from "./MenuToggle.tsx";
import { Navigation } from "./Navigation"
import { useDimensions } from "./use-dimensions";
import "./navbar.scss"
import logo from '../../images/Nav Logo.png'
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { Link } from "react-router-dom";
import { useState } from 'react';
import { HashLink } from 'react-router-hash-link';

// const sidebar = {
//   open: (height = 1000) => ({
//     clipPath: `circle(${height * 2 + 200}px at 40px 40px)`,
//     transition: {
//       type: "spring",
//       stiffness: 20,
//       restDelta: 2
//     }
//   }),
//   closed: {
//     clipPath: "circle(30px at 40px 40px)",
//     transition: {
//       delay: 0.5,
//       type: "spring",
//       stiffness: 400,
//       damping: 40
//     }
//   }
// };

function Navbar() {

  // const [isOpen, toggleOpen] = useCycle(false, true);
  // const containerRef = useRef(null);
  // const { height } = useDimensions(containerRef);
  

  const [sidebar, setSidebar] = useState(false);

  const showSidebar = () => setSidebar(!sidebar);


  return (
    <div className="navbar">
      <Link to="/" className="navlogo">
        <img src={logo} alt="Iva logo" className="logoImg" />
      </Link>

      <div className="hamburgerBtn">
        <div className="navbar">
          <Link to="#" className="menu-bars" style={{ textDecoration: "none", color: "#ffff" }}>
            <MenuOutlinedIcon onClick={showSidebar} className="icon"/>
          </Link>
        </div>
        <nav className={sidebar ? "nav-menu active" : "nav-menu"}>
          <ul className="nav-menu-items" onClick={showSidebar}>
            <li className="navbar-toggle">
              <Link to="#" className="menu-bars" style={{ textDecoration: "none", color: "#ffff" }}>
                <CloseOutlinedIcon />
              </Link>
            </li>
            
            <li className='nav-text'>
          <HashLink to={{pathname: '/', hash: '#about'}} style={{ textDecoration: "none", color: "#FFFF" }}>
            About Us
          </HashLink>
        </li>
        <li className='nav-text'>
          <HashLink to="/#services" style={{ textDecoration: "none", color: "#FFFF" }}>
            Our Services
          </HashLink>
        </li>
        <li className='nav-text'>
          <HashLink to="/#team" style={{ textDecoration: "none", color: "#FFFF" }}>
          Meet The Team
          </HashLink>
        </li>
        <li className='nav-text'>
          <HashLink to="/#contact" style={{ textDecoration: "none", color: "#FFFF" }}>
          Contact Us
          </HashLink>
        </li>
          </ul>
        </nav>
      </div>

      {/* <motion.nav
        className="hamburgerBtn"
        initial={false}
        animate={isOpen ? "open" : "closed"}
        custom={height}
        ref={containerRef}
      >
        <motion.div className="background" variants={sidebar} />
        <Navigation />
        <ul>
        <li>About Us</li>
        <li>Our Services</li>
        <li>Meet The Team</li>
        <li>Contact Us</li>
      </ul>
        <MenuToggle toggle={() => toggleOpen()} />
        
      </motion.nav> */}

      <ul className='navLinks'>
        <li>
          <HashLink to={{pathname: '/', hash: '#about'}} style={{ textDecoration: "none", color: "#FFFF" }}>
            About Us
          </HashLink>
        </li>
        <li>
          <HashLink to="/#services" style={{ textDecoration: "none", color: "#FFFF" }}>
            Our Services
          </HashLink>
        </li>
        <li>
          <HashLink to="/#team" style={{ textDecoration: "none", color: "#FFFF" }}>
          Meet The Team
          </HashLink>
        </li>
        <li>
          <HashLink to="/#contact" style={{ textDecoration: "none", color: "#FFFF" }}>
          Contact Us
          </HashLink>
        </li>
    
      </ul>

      <ul></ul>
    </div>
  );
}

export default Navbar
